/**
 * 页面常量定义
 */

// 高德地图 Key
export const AMAP_KEY: string = "e9c4e1537725c67ae982d59e02c6eca4";
// 高德地图版本号
export const AMAP_VERSION: string = "1.4.15"; // 1.4.15
export const AMAP_UI_VERSION: string = "1.0";

// 高德地图插件
export const AMAP_PLUGINS: string[] = [
  // 'AMap.ToolBar',
  'AMap.ControlBar',
  'AMap.Geolocation',
  // 'AMap.Autocomplete'
];

export const AMAP_SCRIPT_CALLBACK_NAME = '__amap_init_callback';

export const AMAP_MAIN_SCRIPT_URL = 
  `//webapi.amap.com/maps?v=${AMAP_VERSION}&key=${AMAP_KEY}&callback=${AMAP_SCRIPT_CALLBACK_NAME}&plugin=${AMAP_PLUGINS.join(',')}`

export const AMAP_UI_SCRIPT_URL = 
  `//webapi.amap.com/ui/${AMAP_UI_VERSION}/main-async.js`
